import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
    data () {

    },
    created: function () {

    },
    computed: {
        ...mapGetters({
            users: 'data/users',
        }),
    },
    methods: {
        formatDate(value){
            if (value) {
                return moment(String(value)).format('MM/DD/YYYY')
            }
        },
        getUsername(id) {
            let users = this.users.filter(user => {
              return user.id == id
            })

            if(users.length > 0) {
                return users[0].name
            } else {
                return ''
            }
        }
    }
 }